/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const libraly = () => {
		const latestArea = document.querySelector('.js-irLibraly-latest');
		const blockAreaWrap = document.querySelector('.js-irLibraly-block');
		const blockArea = document.querySelector('.js-irLibraly-block > ul');
		const bytesToSize = (bytes) => {
			var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
			if (bytes === 0) {
				return 'n/a';
			}
			var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
			if (i === 0) {
				return bytes + ' ' + sizes[i];
			}
			return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
		}
		const getJSONfiles = () => {
			if(location.pathname.split('/')[3] == 'results') {
				return `/ajax/ir/ir_library/results.json`;
			} else if(location.pathname.split('/')[3] == 'securities_report') {
				return `/ajax/ir/ir_library/securities_report.json`;
			} else if(location.pathname.split('/')[3] == 'management_plan') {
				return `/ajax/ir/ir_library/management_plan.json`;
			} else if(location.pathname.split('/')[3] == 'briefing') {
				return `/ajax/ir/ir_library/briefing.json`;
			} else if(location.pathname.split('/')[3] == 'business_report') {
				return `/ajax/ir/ir_library/business_report.json`;
			} else if(location.pathname.split('/')[3] == 'other') {
				return `/ajax/ir/ir_library/other.json`;
			}
		};
		const HTML1 = (_type,_title,_href,_size,_year,_month,_day,_type3size) => {
			let title = `${_title} (${_year}年${_month}月${_day}日)`;
			if(_title.indexOf('(訂正') !== -1) {
				title = `└ ${_title}`;
			}
			if(_type == '2') {
				return `<li><p class="ico_pdf"><a href="${_href}" target="_blank">${title}<span class="ico_pdf_in">(${_size})</span></a></p></li>`;

			} else if(_type == '3') {
				if(_type3size) {
					return `<li><p class="ico_pdf"><a href="${_href}" target="_blank">${title}<span class="ico_pdf_in">(${_type3size})</span></a></p></li>`;
				} else {
					return `<li><p class="ico_external"><a href="${_href}" target="_blank">${title}</a></p></li>`;
				}
			}
		};
		document.querySelectorAll('.js-pdfByte').forEach(function (pdfElement) {
			pdfElement.innerText = bytesToSize(pdfElement.innerText);
		});
		fetch(getJSONfiles()).then(function (data) {
			return data.json();
		}).then(function (data) {
			console.log(data,'data');
			const groups = new Map();
			let latestdate1 = new Date(data.rt_bn_news_list[0].cf_n_date);
			let latestyear = latestdate1.getFullYear();
			let latestmonth = (latestdate1.getMonth()+1);
			if(6 < latestmonth) {
				latestyear += 1;
			}
			data.rt_bn_news_list.forEach(elem => {
				// console.log(elem,'elem');
				let date1 = new Date(elem.cf_n_date);
				let year = date1.getFullYear();
				let section = date1.getFullYear();
				let month = (date1.getMonth()+1);
				let day = date1.getDate();
				let size = '';
				let typesize = 0;
				if(elem.cf_n_attachment_file_size) {
					size = bytesToSize(elem.cf_n_attachment_file_size);
				}
				if(6 < month) {
					section += 1;
				}
				if(!groups.has(section)) {
					groups.set(section, [] );
				}
				if(elem.cf_n_url_file_size) {
					typesize = bytesToSize(elem.cf_n_url_file_size);
				}
				groups.get(section).push({
					href: elem.rt_cf_n_href.href,
					title: elem.cf_n_title,
					size: size,
					section: section,
					year: year,
					month: month,
					day: day,
					type: elem.cf_n_type,
					type3size: typesize,
				});
			});
			// console.log(groups,'groups');
			// console.log(groups.size,'groups.size');
			if(!(2 > groups.size)) {
				blockAreaWrap.style.display = 'block';
			}
			groups.forEach((elem, index) => {
				let HTML = ''; 
				// console.log(elem, index,'groupselem');
				if(index == latestyear) {
					elem.forEach(item => {
						HTML += HTML1(item.type,item.title,item.href,item.size,item.year,item.month,item.day,item.type3size);
					});
					// console.log(HTML,'HTML');
					latestArea.insertAdjacentHTML('beforeend', HTML);
					latestArea.insertAdjacentHTML('beforebegin', `<h4 class="ir-head-new">${index}年3月期</h4>`);
				} else {
					HTML = `<li>
					<h4 class="ico_plus">${index}年3月期</h4>
					<ul class="ul_news hide">`;
					elem.forEach(item => {
						HTML += HTML1(item.type,item.title,item.href,item.size,item.year,item.month,item.day,item.type3size);
					});
					HTML += `</ul></li>`;
					blockArea.insertAdjacentHTML('beforeend', HTML);
				}
			});
			document.querySelectorAll(".ul_accordion li h4").forEach(function (h4Element) {
				h4Element.addEventListener("click", function () {
					var ulNewsElement = this.parentElement.querySelector(".ul_news");
					if (ulNewsElement.classList.contains('hide')) {
						ulNewsElement.classList.remove('hide');
						this.classList.toggle('ico_plus');
						this.classList.toggle('ico_minus');
					} else {
						ulNewsElement.classList.add('hide');
						this.classList.toggle('ico_minus');
						this.classList.toggle('ico_plus');
					}
				});
			});
		});
	};

	libraly();


})(window.FUNCTIONS);
